import React from "react";
import styles from "@/css/result.module.less";

const ShareHeader = ({ handleBtnClickCb }) => {
  return (
    <div className={styles["share-hader-wapper"]}>
      <img
        src={require("@/images/app-result/logo.png")}
        alt="logo"
        className={styles["share-header-logo"]}
      />
      <div className={styles["share-header-text"]}>
        <p className={styles["share-header-name"]}>
          星域测速
          <i className={styles["share-header-tag"]}>5G</i>
        </p>
        <p>百万节点 更快更准 5G测速</p>
      </div>
      <button
        className={`${styles["result-btn"]} ${styles["fill-btn"]} ${styles["share-btn"]}`}
        onClick={handleBtnClickCb}
      >
        打开
      </button>
    </div>
  );
};
export default ShareHeader;
